import { Slide, Snackbar, type SlideProps } from '@mui/material';
import {
  type FC,
  type PropsWithChildren,
  type SyntheticEvent,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { Toast } from './Toast';
import { ToastContext } from './ToastContext';
import { setGlobalToastHandler } from './toastHandler';

export const ToastWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState<'error' | 'success'>('error');
  const [message, setMessage] = useState('');

  const handleClose = (_: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction='down' />;
  }

  const showSuccess = useCallback((message: string) => {
    setColor('success');
    setMessage(message);
    setOpen(true);
  }, []);

  const showError = useCallback((message: string) => {
    setColor('error');
    setMessage(message);
    setOpen(true);
  }, []);

  // Set up global toast handler
  useEffect(() => {
    setGlobalToastHandler({ showSuccess, showError });

    return () => {
      setGlobalToastHandler(null);
    };
  }, [showSuccess, showError]);

  return (
    <ToastContext.Provider value={{ showSuccess, showError }}>
      <Snackbar
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        slots={{ transition: SlideTransition }}
        autoHideDuration={15000}
        sx={{ zIndex: !open ? '-1' : '1400' }}
      >
        <Toast color={color} message={message} onClose={handleClose} />
      </Snackbar>

      {children}
    </ToastContext.Provider>
  );
};
